import {
  StyledGraphWrapper,
  StyledProgressionOverTime
} from './ProgressionOverTime.style';
import Header from './Header';
import { StyledRowHeader } from '../ProjectProgression.style';
import useProgressionOverTime from './useProgressionOverTime';
import Loader from './Loader';
import Graph from './Graph/Graph';
import TypeSelector from './TypeSelector/TypeSelector';

const ProgressionOverTime = () => {
  const {
    data,
    avgVelocity,
    tooltipsData,
    isLoading,
    granularity,
    setGranularity,
    type,
    setType
  } = useProgressionOverTime();
  return (
    <StyledProgressionOverTime>
      <StyledRowHeader>
        <Header
          granularity={granularity}
          setGranularity={setGranularity}
          type={type}
          avgVelocity={avgVelocity}
          isLoading={isLoading}
        />
      </StyledRowHeader>
      <StyledGraphWrapper>
        <aside>
          <TypeSelector type={type} setType={setType} />
        </aside>
        <main>
          {isLoading ? (
            <Loader />
          ) : (
            <Graph
              data={data}
              granularity={granularity}
              type={type}
              tooltipsData={tooltipsData}
            />
          )}
        </main>
      </StyledGraphWrapper>
    </StyledProgressionOverTime>
  );
};

export default ProgressionOverTime;
